import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  HomeIcon,
  TrophyIcon,
  UserCircleIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/outline";
import {
  HomeIcon as HomeIconSolid,
  TrophyIcon as TrophyIconSolid,
  UserCircleIcon as UserIconSolid,
} from "@heroicons/react/24/solid";

const AUTH_PATHS = ["/auth", "/login", "/register", "/forgot-password", "/reset-password", "/verify-email"];

const NAV_ITEMS = [
  {
    label: "Home",
    to: "/dashboard",
    match: ["/dashboard", "/fixtures"],
    icon: HomeIcon,
    activeIcon: HomeIconSolid,
  },
  {
    label: "Predict",
    to: "/predictions",
    match: ["/predictions", "/table-predictions"],
    primary: true,
  },
  {
    label: "League",
    to: "/leaderboard",
    match: ["/leaderboard"],
    icon: TrophyIcon,
    activeIcon: TrophyIconSolid,
  },
  {
    label: "You",
    to: "/profile",
    match: ["/profile", "/settings", "/season"],
    icon: UserCircleIcon,
    activeIcon: UserIconSolid,
  },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  if (AUTH_PATHS.includes(pathname)) return null;

  const isActive = (item) => item.match.some((p) => pathname.startsWith(p));

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-line pb-safe md:hidden shadow-bar">
      <nav className="grid grid-cols-4 h-16" aria-label="Primary">
        {NAV_ITEMS.map((item) => {
          const active = isActive(item);

          if (item.primary) {
            return (
              <Link
                key={item.to}
                to={item.to}
                aria-current={active ? "page" : undefined}
                className="flex flex-col items-center justify-end pb-1.5 gap-1"
              >
                <span
                  className={`-mt-5 flex items-center justify-center w-12 h-12 rounded-full text-white shadow-md ring-4 ring-white transition-colors ${
                    active ? "bg-brand-hover" : "bg-brand"
                  }`}
                >
                  <PencilSquareIcon className="w-6 h-6" />
                </span>
                <span
                  className={`text-[11px] leading-none font-semibold ${
                    active ? "text-brand" : "text-gray-600"
                  }`}
                >
                  {item.label}
                </span>
              </Link>
            );
          }

          const Icon = active ? item.activeIcon : item.icon;
          return (
            <Link
              key={item.to}
              to={item.to}
              aria-current={active ? "page" : undefined}
              className={`flex flex-col items-center justify-center gap-1 transition-colors ${
                active ? "text-brand" : "text-gray-500 hover:text-gray-700"
              }`}
            >
              <Icon className="w-6 h-6" />
              <span className="text-[11px] leading-none font-semibold">
                {item.label}
              </span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
